class LpBundleSelector extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll("[data-tier]").forEach((tierButton) => {
      tierButton.addEventListener("click", () => this.#selectTier(tierButton, true));
    });

    // #selectTier (not just #broadcast) so the real quantity-selector-component input actually
    // gets set to the pre-selected tier's quantity on load — otherwise it silently stays at
    // whatever the native selector defaults to (1) until a shopper clicks a tier themselves,
    // contradicting the tier that's already showing as selected. userInitiated is false here
    // so the product gallery's hero image is left showing the product's default photo until
    // the shopper actually clicks a tier themselves.
    const initiallySelected = this.querySelector(
      "[data-tier].lp-bundle-selector__tier--selected",
    );
    if (initiallySelected) this.#selectTier(initiallySelected, false);
  }

  /**
   * @param {HTMLElement} tierButton
   */
  #broadcast(tierButton) {
    document.dispatchEvent(
      new CustomEvent("lp-bundle:change", {
        detail: {
          quantity: Number(tierButton.dataset.quantity) || 1,
          tierPosition: tierButton.dataset.tierPosition || "1",
          savings: tierButton.dataset.savings || "",
          perBottle: tierButton.dataset.perBottle || "",
          comparePrice: tierButton.dataset.comparePrice || "",
          protocolName: tierButton.dataset.protocolName || "",
          variantOption: tierButton.dataset.variantOption || "",
          badgePercent: tierButton.dataset.badgePercent || "",
        },
      }),
    );
  }

  /**
   * @param {HTMLElement} tierButton
   * @param {boolean} userInitiated - False for the initial on-load sync, true for an actual click.
   */
  #selectTier(tierButton, userInitiated) {
    this.querySelectorAll("[data-tier]").forEach((button) => {
      button.classList.remove("lp-bundle-selector__tier--selected");
      button.setAttribute("aria-checked", "false");
    });

    tierButton.classList.add("lp-bundle-selector__tier--selected");
    tierButton.setAttribute("aria-checked", "true");

    const quantity = Number(tierButton.dataset.quantity) || 1;
    const variantId = tierButton.dataset.variantId || "";

    const quantityInput = document.querySelector(
      'quantity-selector-component input[ref="quantityInput"]',
    );
    if (quantityInput instanceof HTMLInputElement) {
      quantityInput.value = String(quantity);
      quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const sectionScope = this.closest('[id^="shopify-section-"]') || document;

    if (variantId) {
      const variantIdInput = sectionScope.querySelector(
        'product-form-component [ref="variantId"]',
      );
      if (variantIdInput instanceof HTMLInputElement) {
        variantIdInput.value = variantId;
      }

      const directCheckout = sectionScope.querySelector("lp-direct-checkout");
      if (directCheckout instanceof HTMLElement) {
        directCheckout.dataset.variantId = variantId;
      }
    }

    // Only swap the gallery's hero photo on an actual click, never on the initial on-load
    // sync — the gallery should default to the product's own photo, and only switch to a
    // variant-specific one once the shopper has explicitly picked a tier.
    if (userInitiated) {
      const variantImage = tierButton.dataset.variantImage || "";
      if (variantImage) {
        const heroImage = sectionScope.querySelector(
          "media-gallery .product-media-container .product-media__image",
        );
        if (heroImage instanceof HTMLImageElement) {
          heroImage.removeAttribute("srcset");
          heroImage.removeAttribute("sizes");
          heroImage.src = variantImage;
          heroImage.alt = tierButton.dataset.variantImageAlt || heroImage.alt;
        }
      }
    }

    this.#broadcast(tierButton);
  }
}

if (!customElements.get("lp-bundle-selector")) {
  customElements.define("lp-bundle-selector", LpBundleSelector);
}
